module.exports = __webpack_public_path__ + "static/img/a64bedf3155c79ff918a330d3d3b43a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_wugan.png
// module id = QvU+
// module chunks = 1